module.exports = __webpack_public_path__ + "img/login-s.90782865.png";